import type { CreateUserInput, UpdateUserInput, UserPublic } from '@container-system/shared';
import { apiRequest } from './client';

export interface RefreshTokenSummary {
  id: string;
  deviceInfo: string | null;
  ipAddress: string | null;
  createdAt: string;
  expiresAt: string;
}

export const usersApi = {
  list: () => apiRequest<UserPublic[]>('/api/users'),
  create: (input: CreateUserInput) => apiRequest<UserPublic>('/api/users', { method: 'POST', body: JSON.stringify(input) }),
  update: (id: string, input: UpdateUserInput) => apiRequest<UserPublic>(`/api/users/${id}`, { method: 'PATCH', body: JSON.stringify(input) }),
  remove: (id: string) => apiRequest<null>(`/api/users/${id}`, { method: 'DELETE' }),
  tokens: (id: string) => apiRequest<RefreshTokenSummary[]>(`/api/users/${id}/tokens`),
  revokeToken: (id: string, tokenId: string) => apiRequest<null>(`/api/users/${id}/tokens/${tokenId}`, { method: 'DELETE' }),
};
